module.exports.isNode = false;